(function () {
  'use strict';

  var STORAGE_KEY = 'preworn:wishlist';

  function countItems() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      var items = stored ? JSON.parse(stored) : [];
      return Array.isArray(items) ? items.length : 0;
    } catch (error) {
      return 0;
    }
  }

  function updateWishlistCount(event) {
    var count = event && event.detail && typeof event.detail.count === 'number'
      ? event.detail.count
      : countItems();
    var badges = document.querySelectorAll('[data-pw-wishlist-count]');
    var links = document.querySelectorAll('.pw-header-wishlist');

    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count > 99 ? '99+' : String(count);
      badges[i].hidden = count === 0;
    }

    for (var j = 0; j < links.length; j++) {
      links[j].setAttribute('aria-label', count ? 'Wishlist, ' + count + ' saved items' : 'Wishlist, empty');
    }
  }

  window.addEventListener('preworn:wishlist-change', updateWishlistCount);
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) updateWishlistCount();
  });
  window.addEventListener('pageshow', updateWishlistCount);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCount);
  } else {
    updateWishlistCount();
  }
})();
